export default function(name) {
    let formatedName = name.toUpperCase();
    let substr = formatedName.split(" ");
    let result = substr[0];
    if (substr[1]) {
        result += `-${substr[1]}`;
    }
    return result;
}
